import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useClientes } from '../../../../contexts/Clientes';
import { FormControlLabel, Switch, Typography } from '@material-ui/core';
import { contatoNovoCliente, InterfaceNovoCliente, referenciaNovoCliente, RamoAtividade, Segmento } from '../../interfaces';
import { IoMdAddCircle } from 'react-icons/io';
import { FaSearch } from 'react-icons/fa';
import { MdDeleteForever } from 'react-icons/md';
import { TextOnlyTooltip } from '../../../../themes/components/TextOnlyTooltip';
import { FieldDropdown, FieldDropdownVer2 } from '../../../../themes/components/FieldDropdown';
import { converterStringValorEmFloat, formatarStringQuantidade, mascaraCEP, mascaraCNPJ, mascaraCPF, mascaraDataDDMMAAAA, mascaraTelefones, mascaraValorEmReal, validaCnpj, validaCpf, validaEMAIL, validaInsEstadual } from '../../../../util/fieldMasks';
import moment from 'moment';
import { buscarCEPCliente } from '../../apis/serviceCliente';
import { Toast } from '../../../../themes/components/Toast';
import { useModals } from '../../../../contexts/Modals';
import { usePedidos } from '../../../../contexts/Pedidos';
import { ArrayCondicaoPagamento, CondicaoPagamento } from '../../../pedidos/interfaces';
import { saveInSessionStorage, getFromSessionStorage } from '../../../../contexts/LocalStorage';

interface PropsFormularioNovoCliente {
    handleChangeCliente: (event: React.ChangeEvent<any> | { target: { name: string, value: string | undefined } }) => void,
    handleChangeContatos: (event: React.ChangeEvent<any> | { target: { name: string, value: string } }, index: number) => void,
    handleChangeReferencias: (event: React.ChangeEvent<any> | { target: { name: string, value: string } }, index: number) => void,
    novoCliente: InterfaceNovoCliente,
    setNovoCliente: Dispatch<SetStateAction<InterfaceNovoCliente>>,
    changeNovoCliente: (nvCliente: InterfaceNovoCliente) => void,
    contatos: contatoNovoCliente[],
    setContatos: Dispatch<SetStateAction<contatoNovoCliente[]>>,
    referencias: referenciaNovoCliente[],
    setReferencias: Dispatch<SetStateAction<referenciaNovoCliente[]>>
}

export function FormularioNovoCliente(props: PropsFormularioNovoCliente) {
    const history = useHistory();
    const [endCobranca, setEndCobranca] = useState(false);
    const { buscarCondPGTO } = usePedidos();
    const { consultarRamoAtividade, consultarSegmento, consultaCNPJ } = useClientes();
    const { mostrarInfoOK, mostrarModalProgress, setShowModalProgress } = useModals();
    const [value, setValue] = useState(0);
    const [listaCondPGTO, setListaCondPGTO] = useState<ArrayCondicaoPagamento>();
    const [listaRamoAtividade, setListaRamoAtividade] = useState<RamoAtividade[]>();
    const [listaSegmento, setListaSegmento] = useState<Segmento[]>();
    const [loadingCondicaoPGTO, setLoadingCondicaoPGTO] = useState<boolean>(false);
    const [fieldCondPagamento, setFieldCondPagamento] = useState<CondicaoPagamento | undefined>(getFromSessionStorage("tempCond") !== null ? JSON.parse(String(getFromSessionStorage("tempCond"))) : undefined);
    const [loadingRamo, setLoadingRamo] = useState<boolean>(false);
    const [loadingSegmento, setLoadingSegmento] = useState<boolean>(false);
    const [fieldRamoAtividade, setFieldRamoAtividade] = useState<RamoAtividade | undefined>(getFromSessionStorage("tempRamo") !== null ? JSON.parse(String(getFromSessionStorage("tempRamo"))) : undefined);
    const [fieldSegmento, setFieldSegmento] = useState<Segmento | undefined>(getFromSessionStorage("segmento") !== null ? JSON.parse(String(getFromSessionStorage("segmento"))) : undefined);
    const tipoCliente = [
        { "cod": "F", "nome": "Pessoa Física" },
        { "cod": "J", "nome": "Pessoa Jurídica" }];
    const tipoContato = [
        { "cod": "C", "nome": "Comercial" },
        { "cod": "F", "nome": "Financeiro" }];
    const listaEstados = [
        { "nome": "Acre", "sigla": "AC" },
        { "nome": "Alagoas", "sigla": "AL" },
        { "nome": "Amapá", "sigla": "AP" },
        { "nome": "Amazonas", "sigla": "AM" },
        { "nome": "Bahia", "sigla": "BA" },
        { "nome": "Ceará", "sigla": "CE" },
        { "nome": "Distrito Federal", "sigla": "DF" },
        { "nome": "Espírito Santo", "sigla": "ES" },
        { "nome": "Goiás", "sigla": "GO" },
        { "nome": "Maranhão", "sigla": "MA" },
        { "nome": "Mato Grosso", "sigla": "MT" },
        { "nome": "Mato Grosso do Sul", "sigla": "MS" },
        { "nome": "Minas Gerais", "sigla": "MG" },
        { "nome": "Pará", "sigla": "PA" },
        { "nome": "Paraíba", "sigla": "PB" },
        { "nome": "Paraná", "sigla": "PR" },
        { "nome": "Pernambuco", "sigla": "PE" },
        { "nome": "Piauí", "sigla": "PI" },
        { "nome": "Rio de Janeiro", "sigla": "RJ" },
        { "nome": "Rio Grande do Norte", "sigla": "RN" },
        { "nome": "Rio Grande do Sul", "sigla": "RS" },
        { "nome": "Rondônia", "sigla": "RO" },
        { "nome": "Roraima", "sigla": "RR" },
        { "nome": "Santa Catarina", "sigla": "SC" },
        { "nome": "São Paulo", "sigla": "SP" },
        { "nome": "Sergipe", "sigla": "SE" },
        { "nome": "Tocantins", "sigla": "TO" }];

    useEffect(() => {
        if (props.novoCliente.condicaopagamento === undefined) {
            setFieldCondPagamento(undefined);
        }
        if (props.novoCliente.ramoatividade === undefined) {
            setFieldRamoAtividade(undefined);
        }
        getSegmento("");
    }, [props.novoCliente])

    function fieldForm(label: string, value: string, id: string) {
        let tempValorCampo = value
        let campoValido: boolean = true
        if (value.length < 3 || value.length > 100) {
            campoValido = false
        } else {
            campoValido = true
        }

        switch (id) {
            case "telefone2":
                if (value.length < 10) {
                    campoValido = false
                } else {
                    campoValido = true
                }
                tempValorCampo = mascaraTelefones(tempValorCampo);
                break;
            case "telefone1":
                if (value.length < 10) {
                    campoValido = false
                } else {
                    campoValido = true
                }
                tempValorCampo = mascaraTelefones(tempValorCampo);
                break;
            case "insestadual":
                if (validaInsEstadual(value)) {
                    campoValido = true
                } else {
                    campoValido = false
                }
                break;
            case "complementoendereco":
                campoValido = true
                break;
            case "complentocobranca":
                campoValido = true
                break;
            case "numerocobranca":
                if (value.length < 1) {
                    campoValido = false
                } else {
                    campoValido = true
                }
                break;
            case "numeroendereco":
                if (value.length < 1) {
                    campoValido = false
                } else {
                    campoValido = true
                }
                break;
            case "ufendereco":
                if (value.length < 1) {
                    campoValido = false
                } else {
                    campoValido = true
                }
                break;
            case "ufcobranca":
                if (value.length < 1) {
                    campoValido = false
                } else {
                    campoValido = true
                }
                break;
            default:
                break;
        }

        return (
            <div className="form-line-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className="cliente-linha-campo">
                        <input type="text" className={campoValido === true ? "form-control" : "form-control erro-campo"} id={id} name={id}
                            onChange={(event: React.ChangeEvent<any>) => event.target.name === "telefone1" || event.target.name === "telefone2" ? props.handleChangeCliente({ target: { name: event.target.name, value: event.target.value.replace(new RegExp("[^\\d]", 'g'), "").substring(0, 11) } })
                                :
                                event.target.name === "numeroendereco" || event.target.name === "numerocobranca" ? props.handleChangeCliente({ target: { name: event.target.name, value: event.target.value.replace(new RegExp("[^\\d]", 'g'), "").substring(0, 5) } })
                                    :
                                    event.target.name === "complentocobranca" || event.target.name === "complementoendereco" ? props.handleChangeCliente({ target: { name: event.target.name, value: event.target.value.substring(0, 10) } })
                                        :
                                        event.target.name === "insestadual" ? props.handleChangeCliente({ target: { name: event.target.name, value: event.target.value.substring(0, 30) } })
                                            :
                                            event.target.name === "endereco" || event.target.name === "enderecocobranca" ? props.handleChangeCliente({ target: { name: event.target.name, value: event.target.value.substring(0, 22) } })
                                                :
                                                event.target.name === "bairroendereco" || event.target.name === "bairrocobranca" ? props.handleChangeCliente({ target: { name: event.target.name, value: event.target.value.substring(0, 70) } })
                                                    :
                                                    props.handleChangeCliente(event)
                            }
                            value={tempValorCampo}
                        />
                    </div>
                </div>
            </div>
        )
    }

    function handleChangeCondicaoPGTO(event: any, option: string, reason: any) {
        let cod = "";
        let desc = "";

        async function getCondicao() {
            if (new RegExp("[0-9]+", 'g').test(event.target.value)) {
                cod = event.target.value as string;
            } else {
                desc = event.target.value as string;
            }
            await buscarCondPGTO(cod, desc, history)
                .then((res) => {
                    setListaCondPGTO(res);
                    setLoadingCondicaoPGTO(false);
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaCondPGTO([]);
                        setLoadingCondicaoPGTO(false);
                    }
                })
        }

        if (event !== null && event.target.value !== "" && reason === "input") {
            console.log(event.target.value);
            setLoadingCondicaoPGTO(true);
            getCondicao();
        }

        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]+").exec(option)
            //Setando o código selecionado no corpo do novo pedido
            props.handleChangeCliente({ target: { name: "condicaopagamento", value: cod ? cod[0] : undefined } })

            if (cod !== null) {
                if (listaCondPGTO !== undefined) {
                    for (let index = 0; index < listaCondPGTO.length; index++) {
                        const element = listaCondPGTO[index];
                        if (cod !== null && element.codcpg === cod[0]) {
                            setFieldCondPagamento(element);
                            saveInSessionStorage("tempCond", JSON.stringify(element));
                            break;
                        }
                    }
                }
            }
        }

        if (reason === "clear") {
            props.handleChangeCliente({ target: { name: "condicaopagamento", value: undefined } });
            setFieldCondPagamento(undefined);
        }
    };

    async function getRamoAtividade(text: string) {
        await consultarRamoAtividade(text, history)
            .then((res) => {
                setListaRamoAtividade(res);
                setLoadingRamo(false);
            })
            .catch((err) => {
                if (err !== "Cancel") {
                    setListaRamoAtividade([]);
                    setLoadingRamo(false);
                }
            })
    }

    async function getSegmento(text: string) {
        await consultarSegmento(text, history)
            .then((res) => {
                setListaSegmento(res);
                setLoadingSegmento(false);
            })
            .catch((err) => {
                if (err !== "Cancel") {
                    setListaSegmento([]);
                    setLoadingSegmento(false);
                }
            })
    }

    function handleChangeRamoAtividade(event: any, option: string, reason: any) {
        let text = "";

        if (event !== null && event.target.value !== "" && reason === "input") {
            // console.log(event.target.value);
            setLoadingRamo(true);
            getRamoAtividade(event.target.value as string);
        }

        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]+").exec(option)
            //Setando o código selecionado no corpo do novo pedido
            props.handleChangeCliente({ target: { name: "ramoatividade", value: cod ? cod[0] : "" } })

            if (cod !== null) {
                if (listaRamoAtividade !== undefined) {
                    for (let index = 0; index < listaRamoAtividade.length; index++) {
                        const element = listaRamoAtividade[index];
                        if (cod !== null && element.codram === cod[0]) {
                            setFieldRamoAtividade(element);
                            saveInSessionStorage("tempRamo", JSON.stringify(element));
                            break;
                        }
                    }
                }
            }
        }

        if (reason === "clear") {
            props.handleChangeCliente({ target: { name: "ramoatividade", value: undefined } });
            setFieldRamoAtividade(undefined);
        }
    };
    function handleChangeSegmento(event: any, option: string, reason: any) {
        let text = "";

        if (event !== null && event.target.value !== "" && reason === "input") {
            console.log(event.target.value);
            setLoadingSegmento(true);
            getSegmento(event.target.value as string);
        }

        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]+").exec(option)
            //Setando o código selecionado no corpo do novo pedido
            props.handleChangeCliente({ target: { name: "segmento", value: cod ? cod[0] : "" } })

            if (cod !== null) {
                if (listaSegmento !== undefined) {
                    for (let index = 0; index < listaSegmento.length; index++) {
                        const element = listaSegmento[index];
                        if (cod !== null && element.codseg === cod[0]) {
                            setFieldSegmento(element);
                            saveInSessionStorage("tempSegmento", JSON.stringify(element));
                            break;
                        }
                    }
                }
            }
        }

        if (reason === "clear") {
            props.handleChangeCliente({ target: { name: "segmento", value: undefined } });
            setFieldSegmento(undefined);
        }
    };

    function fieldFormCondPGTO(label: string, id: string) {
        return (
            <div className="form-line-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className={fieldCondPagamento !== undefined ? "cliente-linha-campo" : "cliente-linha-campo erro-campo"}>
                        <FieldDropdownVer2
                            value={fieldCondPagamento !== undefined ? fieldCondPagamento : ""}
                            id={id}
                            options={listaCondPGTO || []}
                            loading={loadingCondicaoPGTO}
                            select={(option: CondicaoPagamento, value: CondicaoPagamento) => option.codcpg === value.codcpg}
                            label={(option: CondicaoPagamento) => option.codcpg !== undefined ? "[" + option.codcpg + "] " + option.descpg : ""}
                            onChange={(event, option, reason) => handleChangeCondicaoPGTO(event, option, reason)}
                            noOptionsText={"Digite um código ou descrição válido"}
                        />
                    </div>
                </div>
            </div>
        )
    }

    function fieldFormRamoAtividade(label: string, id: string) {
        return (
            <div className="form-line-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className={fieldRamoAtividade !== undefined ? "cliente-linha-campo" : "cliente-linha-campo erro-campo"}>
                        <FieldDropdownVer2
                            value={fieldRamoAtividade !== undefined ? fieldRamoAtividade : ""}
                            id={id}
                            options={listaRamoAtividade || []}
                            loading={loadingRamo}
                            select={(option: RamoAtividade, value: RamoAtividade) => option.codram === value.codram}
                            label={(option: RamoAtividade) => option.codram !== undefined ? "[" + option.codram + "] " + option.desram : ""}
                            onChange={(event, option, reason) => handleChangeRamoAtividade(event, option, reason)}
                            noOptionsText={"Digite um código ou descrição válido"}
                        />
                    </div>
                </div>
            </div>
        )
    }

    function fieldFormSegmento(label: string, id: string) {

        return (
            <div className="form-line-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className={fieldSegmento !== undefined ? "cliente-linha-campo" : "cliente-linha-campo erro-campo"}>
                        <FieldDropdownVer2
                            value={fieldSegmento !== undefined ? fieldSegmento : ""}
                            id={id}
                            options={listaSegmento || []}
                            loading={loadingSegmento}
                            select={(option: Segmento, value: Segmento) => option.codseg === value.codseg}
                            label={(option: Segmento) => option.codseg !== undefined ? "[" + option.codseg + "] " + option.desseg : ""}
                            onChange={(event, option, reason) => handleChangeSegmento(event, option, reason)}
                            noOptionsText={"Digite um código ou descrição válido"}
                        />
                    </div>
                </div>
            </div>
        )
    }

    function fieldFormGupo(label: string, value: string, id: string) {
        let tempValorCampo = value === "" ? "" : value;
        let campoValido: boolean = true
        if (value.length > 50) {
            campoValido = false
        } else {
            campoValido = true
        }

        return (
            <div className="form-line-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className="cliente-linha-campo">
                        <input type="text" className={campoValido === true ? "form-control" : "form-control erro-campo"} id={id} name={id} onChange={(event: React.ChangeEvent<any>) => props.handleChangeCliente({ target: { name: "grupo", value: event.target.value } })} value={tempValorCampo} />
                    </div>
                </div>
            </div>
        )
    }

    function fieldFormCEP(label: string, value: string, id: string) {
        let tempValorCampo = value;
        let campoValido: boolean = true
        if (value.length < 8) {
            campoValido = false
        } else {
            campoValido = true
        }
        tempValorCampo = mascaraCEP(tempValorCampo);

        return (
            <div className="form-line-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className="cliente-linha-campo campo-com-busca-cliente">
                        <input type="text" className={campoValido === true ? "form-control" : "form-control erro-campo"} id={id} name={id} onChange={(event: React.ChangeEvent<any>) => props.handleChangeCliente({ target: { name: id, value: event.target.value.substring(0, 9).replace(new RegExp("[^\\d]", 'g'), "") } })} value={tempValorCampo} />
                        <button type='button' className="button-contato-add" onClick={() => buscarCEP(value, id)}><FaSearch /></button>
                    </div>
                </div>
            </div>
        )
    }

    function buscarCEP(valor: string, campo: string) {
        async function processar() {
            buscarCEPCliente(valor)
                .then(res => {
                    console.log(res);
                    if (res.erro) {
                        mostrarInfoOK("CEP não localizado", "Verifique o campo de CEP ou preencha os outros campos manualmente.");
                    } else {
                        let tempCliente = props.novoCliente
                        if (campo === "cependereco") {
                            tempCliente.endereco = res.logradouro.substring(0, 22);
                            tempCliente.bairroendereco = res.bairro.substring(0, 70);
                            tempCliente.cidadeendereco = res.localidade;
                            tempCliente.ufendereco = res.uf;
                        } else {
                            tempCliente.enderecocobranca = res.logradouro.substring(0, 22);
                            tempCliente.bairrocobranca = res.bairro.substring(0, 70);
                            tempCliente.cidadecobranca = res.localidade;
                            tempCliente.ufcobranca = res.uf;
                        }
                        props.setNovoCliente(tempCliente);
                        setValue(value + 1);
                    }
                })
                .catch(err => {
                    Toast("error", "Erro ao consultar CEP, digite o endereço manualmente!");
                })
        }
        if (valor.length === 8) {
            processar();
        } else {
            mostrarInfoOK("Verifique o campo de CEP", "Valor inválido!");
        }
    }

    function buscarCNPJ(valor: string) {
        async function processar() {
            consultaCNPJ(valor, props.novoCliente.ufendereco, history)
                .then(res => {
                    //console.log(res);
                    let tempCliente = props.novoCliente;
                    //Aplicando valores
                    tempCliente.endereco = res.endereco.substring(0, 22);
                    tempCliente.bairroendereco = res.bairro.substring(0, 70);
                    tempCliente.cidadeendereco = res.cidade;
                    tempCliente.nome = res.razao;
                    tempCliente.fantasia = res.fantasia;
                    tempCliente.numeroendereco = res.numeroEnd.replace(new RegExp("[^\\d]", 'g'), "").substring(0, 5);
                    tempCliente.complementoendereco = res.complementoEnd.substring(0, 10);
                    tempCliente.cependereco = res.cep;
                    tempCliente.telefone1 = res.telefone[0] !== undefined ? res.telefone[0].replace(new RegExp("[^\\d]", 'g'), "") : "";
                    tempCliente.telefone2 = res.telefone[1] !== undefined ? res.telefone[1].replace(new RegExp("[^\\d]", 'g'), "") : "";
                    tempCliente.email = res.email.substring(0, 60);
                    tempCliente.insestadual = res.inscEst.substring(0, 30);
                    props.setNovoCliente(tempCliente);
                    setValue(value + 1);
                    setShowModalProgress(false);
                })
                .catch(err => {
                    if (err.error !== undefined && err.error.includes("Já existe um cliente cadastrado")) {
                        mostrarInfoOK("Clitente já cadastrado!", err.error);
                    } else {
                        mostrarInfoOK("Informações não localizadas", "Verifique o campo de CNPJ ou preencha os campos manualmente.");
                    }
                })
        }
        if (props.novoCliente.ufendereco !== "" && valor !== "") {
            mostrarModalProgress("Consultando CNPJ");
            let tempCliente = props.novoCliente;
            tempCliente.endereco = "";
            tempCliente.bairroendereco = "";
            tempCliente.cidadeendereco = "";
            tempCliente.nome = "";
            tempCliente.fantasia = "";
            tempCliente.numeroendereco = "";
            tempCliente.complementoendereco = "";
            tempCliente.cependereco = "";
            tempCliente.telefone1 = "";
            tempCliente.telefone2 = "";
            tempCliente.email = "";
            tempCliente.insestadual = "";
            props.setNovoCliente(tempCliente);
            setValue(value + 1);
            processar();
        } else {
            mostrarInfoOK("Verifique o campo de Estado e CNPJ", "Valor inválido!");
        }
    }

    function fieldFormSugestaoLimite(label: string, value: string, id: string) {
        let tempValorCampo = value === "" ? "0.00" : value;
        let campoValido: boolean = true
        if (value === "" || parseFloat(value) < 0.01) {
            campoValido = false
        } else {
            campoValido = true
        }

        tempValorCampo = "R$ " + mascaraValorEmReal(tempValorCampo)

        return (
            <div className="form-line-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className="cliente-linha-campo">
                        <input type="text" className={campoValido === true ? "form-control" : "form-control erro-campo"} id={id} name={id} onChange={(event: React.ChangeEvent<any>) => props.handleChangeCliente({ target: { name: "sugestaolimite", value: converterStringValorEmFloat(event.target.value.replace(new RegExp("[^\\d]", 'g'), "")) } })} value={tempValorCampo} />
                    </div>
                </div>
            </div>
        )
    }

    function fieldFormObservacao(label: string, value: string, id: string) {
        let tempValorCampo = value === "" ? "" : value;
        let campoValido: boolean = true
        if (value.length < 20) {
            campoValido = false
        } else {
            campoValido = true
        }

        return (
            <div className="form-line-full-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className="cliente-linha-campo">
                        <input type="text" className={campoValido === true ? "form-control" : "form-control erro-campo"} id={id} name={id} onChange={(event: React.ChangeEvent<any>) => props.handleChangeCliente({ target: { name: "observacao", value: event.target.value } })} value={tempValorCampo} />
                    </div>
                </div>
            </div>
        )
    }

    function fieldFormCPFCNPJ(label: string, value: string, id: string) {
        let tempValue = ""
        let campoValido: boolean = true

        if (props.novoCliente.tipocliente === "F") {
            tempValue = mascaraCPF(value);
            if (value.length !== 11 || validaCpf(value) === false) {
                campoValido = false
            } else {
                campoValido = true
            }
        } else {
            tempValue = mascaraCNPJ(value);
            if (value.length !== 14 || validaCnpj(value) === false) {
                campoValido = false
            } else {
                campoValido = true
            }
        }

        return (
            <div className="form-line-novo-cliente-destaque">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className={props.novoCliente.tipocliente.toLocaleLowerCase() === "j" ? "cliente-linha-campo campo-com-busca-cliente" : "cliente-linha-campo"}>
                        <input type="text" className={campoValido === true ? "form-control" : "form-control erro-campo"} id={id} name={id} onChange={(event: React.ChangeEvent<any>) => props.handleChangeCliente({ target: { name: "cpfcnpj", value: props.novoCliente.tipocliente === "F" ? event.target.value.replace(new RegExp("[^\\d]", 'g'), "").substring(0, 11) : event.target.value.replace(new RegExp("[^\\d]", 'g'), "").substring(0, 14) } })} value={tempValue} />
                        {props.novoCliente.tipocliente.toLocaleLowerCase() === "j" ? <button type='button' disabled={!campoValido} className="button-search-cnpj" onClick={() => buscarCNPJ(value)}><FaSearch /></button> : <></>}
                    </div>
                </div>
            </div>
        )
    }

    function fieldFormTipoContatoDropDown(label: string, campo: string, id: string, index: number) {

        function getCodTipoContato(text: string) {
            for (let index = 0; index < tipoContato.length; index++) {
                const element = tipoContato[index];
                if (element.nome === text) {
                    return element.cod;
                }
            }
            return tipoContato[0].cod;
        }

        function getTipoContatoList() {
            let temp: string[] = []
            tipoContato.forEach((opt) => {
                temp.push(opt.nome)
            })
            return temp;
        }

        function getSelectedOption() {
            let tempContato = props.contatos[index]
            for (let cont = 0; cont < tipoContato.length; cont++) {
                const element = tipoContato[cont];
                if (tempContato !== undefined && element.cod === tempContato.tipo) {
                    return element.nome;
                }
            }
            return tipoContato[0].nome;
        }

        return (
            <div className="form-line-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <FieldDropdown
                        value={getSelectedOption()}
                        id={id}
                        options={getTipoContatoList()}
                        label={(option: string) => option}
                        onChange={(event, newInputValue) => {
                            props.handleChangeContatos({ target: { name: campo, value: getCodTipoContato(newInputValue) } }, index);
                        }}
                    />
                </div>
            </div>
        )
    }

    function fieldFormEstadoDropDown(label: string, campo: string, id: string) {

        function getSiglaEstado(text: string) {
            for (let index = 0; index < listaEstados.length; index++) {
                const element = listaEstados[index];
                if (element.nome === text) {
                    return element.sigla;
                }
            }
            return listaEstados[0].sigla;
        }

        function getEstadoList() {
            let temp: string[] = []
            listaEstados.forEach((opt) => {
                temp.push(opt.nome)
            })
            return temp;
        }

        function getSelectedOption() {
            let tempEstado = (props.novoCliente as any)[campo]
            for (let cont = 0; cont < listaEstados.length; cont++) {
                const element = listaEstados[cont];
                if (tempEstado !== undefined && element.sigla === tempEstado) {
                    return element.nome;
                }
            }
            return listaEstados[0].nome;
        }

        return (
            <div className="form-line-novo-cliente-destaque">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <FieldDropdown
                        value={getSelectedOption()}
                        id={id}
                        options={getEstadoList()}
                        label={(option: string) => option}
                        onChange={(event, newInputValue) => {
                            props.handleChangeCliente({ target: { name: campo, value: getSiglaEstado(newInputValue) } });
                        }}
                    />
                </div>
            </div>
        )
    }

    function fieldFormEmail(label: string, value: string, id: string) {
        let campoValido: boolean = true

        if (validaEMAIL(value) === false) {
            campoValido = false
        } else {
            campoValido = true
        }

        return (
            <div className="form-line-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className="cliente-linha-campo">
                        <input type="text" className={campoValido === true ? "form-control" : "form-control erro-campo"} id={id} name={id} onChange={(event: React.ChangeEvent<any>) => props.handleChangeCliente({ target: { name: "email", value: event.target.value.substring(0, 60) } })} value={value} />
                    </div>
                </div>
            </div>
        )
    }

    function fieldTipoClienteDropDown(label: string, value: string, id: string) {

        function getCodTipoCliente(text: string) {
            for (let index = 0; index < tipoCliente.length; index++) {
                const element = tipoCliente[index];
                if (element.nome === text) {
                    return element.cod;
                }
            }
            return tipoCliente[0].cod;
        }

        function getTipoClienteList() {
            let temp: string[] = []
            tipoCliente.forEach((opt) => {
                temp.push(opt.nome)
            })
            return temp;
        }

        function getSelectedOption() {
            for (let index = 0; index < tipoCliente.length; index++) {
                const element = tipoCliente[index];
                if (element.cod === props.novoCliente.tipocliente) {
                    return element.nome;
                }
            }
            return tipoCliente[0].nome;
        }

        return (
            <div className="form-line-novo-cliente-destaque">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <FieldDropdown
                        value={getSelectedOption()}
                        id={id}
                        options={getTipoClienteList()}
                        label={(option: string) => option}
                        onChange={(event, newInputValue) => {
                            props.handleChangeCliente({ target: { name: value, value: getCodTipoCliente(newInputValue) } });
                        }}
                    />
                </div>
            </div>
        )
    }

    function fieldFormContato(label: string, value: string, id: string, index: number) {
        let tempValorCampo = (props.contatos as any)[index][value]
        let campoValido: boolean = true
        if (tempValorCampo.length < 3) {
            campoValido = false
        } else {
            campoValido = true
        }

        switch (value) {
            case "email":
                if (validaEMAIL(tempValorCampo) === false) {
                    campoValido = false
                } else {
                    campoValido = true
                }
                break;
            case "aniversario":
                if (tempValorCampo) {
                    if (moment(tempValorCampo, "DD/MM/YYYY").isValid() === true && moment(tempValorCampo, "DD/MM/YYYY").isBefore(moment()) === true) {
                        campoValido = true
                    } else {
                        campoValido = false
                    }
                    tempValorCampo = mascaraDataDDMMAAAA(tempValorCampo);
                }else{
                    campoValido = true
                }
                break;
            case "telefone":
                if (tempValorCampo.length < 10) {
                    campoValido = false
                } else {
                    campoValido = true
                }
                tempValorCampo = mascaraTelefones(tempValorCampo);
                break;
            default:
                break;
        }

        return (
            <div className="form-line-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className="cliente-linha-campo">
                        <input type="text" className={campoValido === true ? "form-control" : "form-control erro-campo"} id={id} name={value}
                            onChange={(event: React.ChangeEvent<any>) => event.target.name === "telefone" ?
                                props.handleChangeContatos({ target: { name: event.target.name, value: event.target.value.replace(new RegExp("[^\\d]", 'g'), "").substring(0, 11) } }, index)
                                :
                                event.target.name === "email" ?
                                    props.handleChangeContatos({ target: { name: event.target.name, value: event.target.value.substring(0, 60) } }, index)
                                    :
                                    event.target.name === "aniversario" ?
                                        props.handleChangeContatos({ target: { name: event.target.name, value: event.target.value.trim().substring(0, 10) } }, index)
                                        :
                                        props.handleChangeContatos(event, index)}
                            value={tempValorCampo} />
                    </div>
                </div>
            </div>
        )
    }

    function fieldFormReferencia(label: string, value: string, id: string, index: number) {
        let tempValorCampo: string = (props.referencias as any)[index][value]
        let campoValido: boolean = false;


        switch (value) {
            case "cpfcnpj":
                if (validaCnpj(tempValorCampo) === false) {
                    campoValido = false
                } else {
                    campoValido = true
                }
                tempValorCampo = mascaraCNPJ(tempValorCampo);
                break;
            case "telefone":
                if (tempValorCampo.length < 10) {
                    campoValido = false
                } else {
                    campoValido = true
                }
                tempValorCampo = mascaraTelefones(tempValorCampo);
                break;
            default:
                if (tempValorCampo.length < 3) {
                    campoValido = false
                } else {
                    campoValido = true
                }
                break;
        }

        return (
            <div className="form-line-novo-cliente">
                <div className="form-group-novo-cliente">
                    <label htmlFor={id}>{label}</label>
                    <div className="cliente-linha-campo">
                        <input
                            type="text"
                            className={campoValido === true ? "form-control"
                                :
                                "form-control erro-campo"}
                            id={id}
                            name={value}
                            onChange={(event: React.ChangeEvent<any>) => event.target.name === "cpfcnpj" ?
                                props.handleChangeReferencias({ target: { name: event.target.name, value: event.target.value.replace(new RegExp("[^\\d]", 'g'), "").substring(0, 14) } }, index)
                                :
                                event.target.name === "telefone" ? props.handleChangeReferencias({ target: { name: event.target.name, value: event.target.value.replace(new RegExp("[^\\d]", 'g'), "").substring(0, 11) } }, index)
                                    :
                                    props.handleChangeReferencias(event, index)} value={tempValorCampo}
                        />
                    </div>
                </div>
            </div>
        )
    }

    const handleCobranca = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEndCobranca(event.target.checked);
        props.handleChangeCliente({ target: { name: "temenderecocob", value: event.target.checked === true ? "S" : "N" } })
    };

    function addContato() {
        if (props.contatos.length < 3) {
            let tempContatos = [...props.contatos];
            tempContatos.push({
                "nome": "",
                "email": "",
                "telefone": "",
                "aniversario": "",
                "tipo": ""
            })
            props.setContatos(tempContatos);
        } else {
            mostrarInfoOK("Erro", "Só é possível ter 3 contatos associados.");
        }
    }

    function removerContato(index: number) {
        if (props.contatos.length > 2) {
            let tempContatos = [...props.contatos];
            tempContatos.splice(index, 1);
            props.setContatos(tempContatos);
        } else {
            mostrarInfoOK("Erro", "2 contatos são obrigatórios.");
        }
    }


    function addReferencia() {
        let tempReferencias = [...props.referencias];
        tempReferencias.push({
            "nome": "",
            "telefone": "",
            "cpfcnpj": ""
        })
        props.setReferencias(tempReferencias);
    }

    function removerReferencia(index: number) {
        let tempReferencias = [...props.referencias];
        tempReferencias.splice(index, 1);
        props.setReferencias(tempReferencias);
    }

    return (
        <div className="formulario-novo-cliente-area">
            <Typography className="titulo-novo-cliente">Informações do Cliente</Typography>
            <form className="formulario-novo-cliente space-bottom-form">
                <div className="form-row-novo-cliente">
                    {fieldFormEstadoDropDown("Estado", "ufendereco", "ufendereco")}
                    {fieldTipoClienteDropDown("Tipo Cliente", "tipocliente", "tipocliente")}
                    {fieldFormCPFCNPJ(props.novoCliente.tipocliente === "F" ? "CPF" : "CNPJ", props.novoCliente.cpfcnpj, "cpfcnpj")}
                </div>
            </form>
            <form className="formulario-novo-cliente">
                <div className="form-row-novo-cliente">
                    {fieldForm("Razão Social", props.novoCliente.nome, "nome")}
                    {fieldForm("Nome Fantasia", props.novoCliente.fantasia, "fantasia")}
                    {fieldFormEmail("Email", props.novoCliente.email, "email")}
                    {fieldForm("Telefone Principal", props.novoCliente.telefone1, "telefone1")}
                    {fieldForm("Telefone Secundário", props.novoCliente.telefone2, "telefone2")}
                    {fieldForm("Inscrição Estadual", props.novoCliente.insestadual, "insestadual")}
                    {fieldFormCondPGTO("Condição de Pagamento", "condPGTO")}
                    {fieldFormRamoAtividade("Ramo de Atividade", "ramoAtividade")}
                    {fieldFormSegmento("Segmento", "segmento")}
                    {fieldFormGupo("Grupo", props.novoCliente.grupo, "grupo")}
                    {fieldFormSugestaoLimite("Sugestão de Limite", props.novoCliente.sugestaolimite, "sugestLimite")}
                </div>
                <div className="form-row-novo-cliente">
                    {fieldFormObservacao("Observação/Parecer Financeiro", props.novoCliente.observacao, "observacao")}
                </div>

            </form>
            <Typography className="titulo-novo-cliente"></Typography>
            <form className="formulario-novo-cliente">
                <div className="form-row-novo-cliente">
                    {fieldFormCEP("CEP", props.novoCliente.cependereco, "cependereco")}
                </div>
                <div className="form-row-novo-cliente">
                    {fieldForm("Endereço", props.novoCliente.endereco, "endereco")}
                    {fieldForm("Número", props.novoCliente.numeroendereco, "numeroendereco")}
                    {fieldForm("Complemento", props.novoCliente.complementoendereco, "complementoendereco")}
                    {fieldForm("Bairro", props.novoCliente.bairroendereco, "bairroendereco")}
                    {fieldForm("Cidade", props.novoCliente.cidadeendereco, "cidadeendereco")}
                </div>
            </form>
            <Typography className="titulo-novo-cliente">Endereço de Cobrança</Typography>
            <form className="formulario-novo-cliente">
                <div className="form-row-novo-cliente">
                    <div className="radio-menu-area">
                        <div style={{ display: 'flex', alignItems: 'baseline' }}>
                            <TextOnlyTooltip title="Endereço de cobrança" placement="top">
                                <FormControlLabel
                                    control={<Switch checked={endCobranca} onChange={handleCobranca} />}
                                    label=""
                                />
                            </TextOnlyTooltip>
                            {endCobranca === false ? <Typography style={{ marginRight: '1em' }}>O mesmo do cadastro</Typography> : <Typography style={{ marginRight: '1em' }}>Endereço de cobrança diferente</Typography>}
                        </div>
                    </div>
                </div>
                {endCobranca === true ?
                    <>
                        <div className="form-row-novo-cliente">
                            {fieldFormCEP("CEP", props.novoCliente.cepcobranca, "cepcobranca")}
                        </div>
                        <div className="form-row-novo-cliente">
                            {fieldForm("Endereço", props.novoCliente.enderecocobranca, "enderecocobranca")}
                            {fieldForm("Número", props.novoCliente.numerocobranca, "numerocobranca")}
                            {fieldForm("Complemento", props.novoCliente.complentocobranca, "complentocobranca")}
                            {fieldForm("Bairro", props.novoCliente.bairrocobranca, "bairrocobranca")}
                            {fieldForm("Cidade", props.novoCliente.cidadecobranca, "cidadecobranca")}
                            {fieldFormEstadoDropDown("Estado", "ufcobranca", "ufcobranca")}
                        </div>
                    </>
                    :
                    <></>}
            </form>
            <Typography className="titulo-novo-cliente">Contatos</Typography>
            <form className="formulario-novo-cliente">
                {props.contatos.map((contato: contatoNovoCliente, index: number) => {
                    return (
                        <div key={"cont_" + index}>
                            <div className="button-contato-area">
                                <Typography className="titulo-novo-cliente">Contato {index + 1}</Typography>
                                <button type='button' className="button-contato-remove" onClick={() => removerContato(index)}><MdDeleteForever /></button>
                            </div>
                            <div className="form-row-novo-cliente">
                                {fieldFormContato("Nome", "nome", `nomeContato${index}`, index)}
                                {fieldFormContato("Email", "email", `emailContato${index}`, index)}
                                {fieldFormContato("Telefone", "telefone", `telContato${index}`, index)}
                                {fieldFormContato("Aniversário", "aniversario", `aniverContato${index}`, index)}
                                {fieldFormTipoContatoDropDown("Tipo", "tipo", `tipoContato${index}`, index)}
                            </div>
                        </div>
                    )
                })}
                <div className="button-contato-area">
                    <button type='button' className="button-contato-add" onClick={() => addContato()}><IoMdAddCircle /></button>
                </div>
            </form>


            <Typography className="titulo-novo-cliente">Referências</Typography>
            <form className="formulario-novo-cliente">
                {props.referencias.map((contato: referenciaNovoCliente, index: number) => {
                    return (
                        <div key={"ref_" + index}>
                            <div className="button-contato-area">
                                <Typography className="titulo-novo-cliente">Referência {index + 1}</Typography>
                            </div>
                            <div className="form-row-novo-cliente">
                                {fieldFormReferencia("Nome", "nome", `nomeReferencia${index}`, index)}
                            </div>
                        </div>
                    )
                })}
            </form>
        </div>
    )
}
